export default "__VITE_ASSET__CF6lUY_I__"